export default __webpack_public_path__ + "static/media/speaker.d8d211d4.jpeg";